import { render, staticRenderFns } from "./connect.vue?vue&type=template&id=1213f118&scoped=true&"
import script from "./connect.vue?vue&type=script&lang=js&"
export * from "./connect.vue?vue&type=script&lang=js&"
import style0 from "./connect.vue?vue&type=style&index=0&id=1213f118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1213f118",
  null
  
)

export default component.exports